import type { UserConnectedLeader, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';

export const findById: FindById<'userConnectedLeaders'> = createFindById('userConnectedLeaders');
export const findByIdThrows: FindByIdThrows<'userConnectedLeaders'> = createFindByIdThrows('userConnectedLeaders');

type GetFulfilledUserConnectedLeaders = (state: YammerState) => Record<string, UserConnectedLeader>;
export const getFulfilledUserConnectedLeaders: GetFulfilledUserConnectedLeaders = (state) =>
  state.userConnectedLeaders.fulfilled.byId;
